import {  get } from "../../service/api";

const GetAdminInvoices = async (queryString) => {
    try {
        const response = await get(`/invoice?1=1&${queryString}`);
        return response;
    } catch (error) {
        console.error('Error GetAdminInvoices:', error);
        throw error;
    }
};

export default GetAdminInvoices;